import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckIcon, ClockIcon, FlameIcon } from 'lucide-react';
import { tomos } from '../data/tomos';
export function ProductTomos() {
  return <section className="w-full bg-white px-6 pt-20 pb-10 sm:px-10" data-id="element-114" data-mp="3ar7og27sdduq">
      <div className="mx-auto max-w-6xl" data-id="element-115" data-mp="3fpiyacy2zocy">
        <h2 className="text-center font-heading text-3xl font-bold text-mint-dark sm:text-4xl" data-id="element-116" data-mp="3foho0aow35wa">
          Todo lo que necesitás para sentirte más liviana
        </h2>

        <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-117" data-mp="36oktvtjqdetu">
          {tomos.map((tomo, index) => {
          const hasBg = Boolean(tomo.imagenFondo);
          return <motion.div key={tomo.numero} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="relative flex flex-col items-center overflow-hidden rounded-2xl p-8 text-center shadow-sm" style={hasBg ? {
            border: `2px solid ${tomo.colorBorder}`
          } : {
            border: `2px solid ${tomo.colorBorder}`,
            background: `linear-gradient(180deg, ${tomo.gradientFrom} 0%, #FFFFFF 100%)`
          }} data-id="element-118" data-mp="2wyi0hs8p5yuz" data-mpi={index}>
                {hasBg && <>
                    {/* Lazy-loaded so these off-screen cover photos aren't fetched until the
                        user scrolls near this section (unlike a CSS background-image, which
                        the browser would download immediately regardless of visibility). */}
                    <img src={tomo.imagenFondo} alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" data-id="element-119" data-mp="9odplsszoyaw" />
                    <div className="absolute inset-0" style={{
                background: 'linear-gradient(180deg, rgba(15,23,42,0.4) 0%, rgba(15,23,42,0.72) 100%)'
              }} data-id="element-120" data-mp="yei3lyw3l6oh" />
                  </>}

                <div className="relative z-10 flex flex-col items-center" data-id="element-121" data-mp="bgn77apw79mw">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full" style={hasBg ? {
                backgroundColor: 'rgba(255,255,255,0.2)',
                color: '#FFFFFF'
              } : {
                backgroundColor: `${tomo.colorBorder}1A`,
                color: tomo.colorTextDark
              }} data-id="element-122" data-mp="fhgsdwbyaac3">
                    <BookOpenIcon className="h-6 w-6" aria-hidden="true" data-id="element-123" data-mp="20utd7mi3wwza" />
                  </span>
                  <h3 className="mt-4 text-lg font-bold" style={{
                color: hasBg ? '#FFFFFF' : tomo.colorTextDark
              }} data-id="element-124" data-mp="3lcueyfwmho6w">
                    Tomo {tomo.numero}: {tomo.titulo}
                  </h3>
                  <p className={`mt-3 text-sm font-bold ${hasBg ? 'text-white' : 'text-gray-700'}`} data-id="element-125" data-mp="3bn163mnv7n6c">{tomo.subtitulo}</p>
                  <ul className="mt-5 space-y-2 text-left" data-id="element-126" data-mp="36ohi7gppo1bc">
                    {tomo.bullets.map(bullet => <li key={bullet} className={`flex items-start gap-2 text-[13px] font-bold ${hasBg ? 'text-white' : 'text-gray-500'}`} data-id="element-127" data-mp="32mmg49zyhjwi">
                        <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" style={{
                    color: hasBg ? '#FFFFFF' : tomo.colorBorder
                  }} aria-hidden="true" data-id="element-128" data-mp="2soyagp0tarzk" />
                        <span data-id="element-129" data-mp="lxpdmz3f8j4b">{bullet}</span>
                      </li>)}
                  </ul>
                  <div className="mt-6 flex items-center gap-3 text-xs font-bold" style={{
                color: hasBg ? '#FFFFFF' : tomo.colorTextDark
              }} data-id="element-130" data-mp="txvg9t204omp">
                    <span className="flex items-center gap-1" data-id="element-131" data-mp="k0qs5nolij39">
                      <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-132" data-mp="k2lcp0vyg96t" /> {tomo.tiempo}
                    </span>
                    <span aria-hidden="true" data-id="element-133" data-mp="b7x5h56tkhfd">·</span>
                    <span className="flex items-center gap-1" data-id="element-134" data-mp="b6cefpjprgm9">
                      <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-135" data-mp="fz5ew185g2sj" /> {tomo.kcal}
                    </span>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="mt-16 text-center" data-id="element-136" data-mp="69lzx6nk4t2y">
          <p className="font-heading text-2xl font-bold text-mint-dark sm:text-3xl" data-id="element-137" data-mp="3oefft60az1yq">245 recetas totales diferentes</p>
          <p className="mt-2 text-base text-gray-500" data-id="element-138" data-mp="3sfsk3bnqyx3j">Para desayuno, almuerzo, merienda, cena y postres</p>
        </div>
      </div>
    </section>;
}